module.exports = __webpack_public_path__ + "img/picto-tab-physique.180bb2ae.svg";